import { fetchData } from 'services/fetchData';

import { authStore } from 'stores';

/**
 * Send a request to the API to retrieve a UAR Report with its Approval Rows and Approvals
 * @param {String} uarReportId Id of the UAR Report to retrieve.
 * @param {Object} filterCriteria filter criteria for the report query
 * @param {Boolean} isPasswordless disctates whether a call is passwordless or passwword
 * @returns report
 */
export const getReportWithApprovals = async (uarReportId, filterCriteria, isPasswordless = false) => {
    const { jwtToken } = authStore.getState(isPasswordless ? 'passwordlessSession' : 'passwordSession').value.sessionDetails;

    const httpOptions = {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
            'Content-Type': 'application/json'
        },
        method: 'GET',
        withCredentials: true
    };

    // If provided filter criteria stringify, otherwise pass blank criteria
    const requestPath = `/uarReport/withApprovalRowsandApprovals/${uarReportId}?filterCriteria=${JSON.stringify(filterCriteria ?? { approvalRow: {} })}&isPasswordless=${isPasswordless}`;
    const { data } = await fetchData(requestPath, httpOptions);
    return data;
};
